import { AddDeviceCurrentLicense } from 'pages/displays/organisms/AddDeviceByCode/AddDeviceByCode-types'
import { DisplayLicenseOption } from 'pages/displays/__add/displays__add.local.methods'
import { useEffect, useState } from 'react'
import { api } from 'core/api/ConnectionManager'
import { licenseType, rateTypeRename } from 'core/utils/displayUtil'
import { useTypedAuthenticatedSelector, useTypedSelector } from 'core/store/hooks'
import { IAuthenticatedUserState } from 'blocks.app/user/user.state'
import { getURLSearchParamsByLocation } from 'features/routes/utils'
import { useLocation } from 'react-router'
import { useDispatch } from 'react-redux'
import { approve, IDisplaysState } from 'pages/displays/displays.state'
import helpersDisplays from 'core/helpers/_digitalSignages'
import helpers from 'core/helpers'

const DraftDevicesMethods = () => {
    const [selectedInfo, setSelectedInfo] = useState<any>(null)
    const [selectedItems, setSelectedItems] = useState<{ id: number }[]>([])
    const [openRegisterModal, setOpenRegisterModal] = useState<boolean>(false)
    const [currentLicense, setCurrentLicense] = useState<AddDeviceCurrentLicense>({ id: null })
    const [licensesData, setLicensesData] = useState<DisplayLicenseOption[]>([])
    const [isLicenseNull, setIsLicenseNull] = useState<boolean>(false)
    const [folders, setFolders] = useState<any>([])
    const [selectedFolderId, setSelectedFolderId] = useState<any>(null)

    const location = useLocation()
    const { data } = useTypedAuthenticatedSelector<IAuthenticatedUserState>((state) => state.user)
    const { approveToken } = useTypedSelector<IDisplaysState>((state) => state.displays)
    const dispatch = useDispatch()

    const onChangeFolder = (selected: any) => {
        setSelectedFolderId(selected.id)
    }

    const getLicenses = (companyId: number) => {
        api.send('getLicenseByFilters', {
            sort: [['licenseId', 'ASC']],
            limit: 1000,
            companyId: companyId,
        }).then((res: any) => {
            let optionFormat = res.data
                .filter((data: any) => data.activeQ)
                .map((opt: any) => ({
                    id: opt.licenseId,
                    name: rateTypeRename(opt.rateType || '') + ' (' + licenseType(opt) + ')',
                    vacantCount: opt.vacantCount,
                    devicesCount: opt.devicesCount,
                    expiredAt: opt.expiredAt,
                    paidQ: opt.paidQ,
                    activeQ: opt.activeQ,
                }))
            setLicensesData(optionFormat)
        })
    }
    const checkEmptyLicences = (licences: any) => {
        return licences.some((licence: any) => licence.vacantCount)
    }

    const registerDevices = () => {
        api.send(
            'registerDraftDevice',
            helpersDisplays.isCheckLicenseQ()
                ? {
                      id:
                          selectedItems === undefined || selectedItems.length == 0
                              ? [selectedInfo.id]
                              : selectedItems.map((selectedItem) => selectedItem.id),
                      licenseId: currentLicense.id,
                      folderId: selectedFolderId,
                  }
                : {
                      id:
                          selectedItems === undefined || selectedItems.length == 0
                              ? [selectedInfo.id]
                              : selectedItems.map((selectedItem) => selectedItem.id),
                      folderId: selectedFolderId,
                  }
        ).then(() => {
            setSelectedItems([])
            setOpenRegisterModal(false)
        })
    }

    useEffect(() => {
        if (openRegisterModal) {
            getLicenses(data.companyId)
            getFolders()
            if (!approveToken) return

            const tokenHasEmptyFields = approveToken ? approveToken.includes('_') : false

            if (!tokenHasEmptyFields) {
                const query = getURLSearchParamsByLocation(location)

                if (query.add_display_code) {
                    setTimeout(() => {
                        dispatch(approve({ licenseId: currentLicense.id }))
                    }, 2500)

                    return
                }

                dispatch(approve({ licenseId: currentLicense.id }))
            }
        }
    }, [approveToken, openRegisterModal])

    const getFolders = () => {
        const digitalSignageId =
            selectedItems.length > 0 || selectedInfo
                ? selectedItems === undefined || selectedItems.length == 0
                    ? [selectedInfo.id]
                    : selectedItems.map((selectedItem) => selectedItem.id)
                : []
        api.send('getAvailableParentGroups', { digitalSignageId, nestedQ: false }, { hideLoader: true }).then(
            (availableGroups: any) => {
                const groups = helpers.addParentKeyIdForTree(availableGroups, 'parentId')
                setFolders(groups)
            }
        )
    }

    return {
        selectedInfo,
        selectedItems,
        setSelectedInfo,
        setSelectedItems,
        openRegisterModal,
        setOpenRegisterModal,
        currentLicense,
        setCurrentLicense,
        licensesData,
        setLicensesData,
        isLicenseNull,
        setIsLicenseNull,
        checkEmptyLicences,
        registerDevices,
        selectedFolderId,
        folders,
        onChangeFolder,
    }
}

export default DraftDevicesMethods
